import { createBrowserRouter } from "react-router-dom";
import Dashboard from "../layouts/AdminPortal/Dashboard";
import Main from "../layouts/StudentPortal/Main";
import AdminDashboard from "../pages/AdminPortal/AdminDashboard";
import AdminLogin from "../pages/AdminPortal/AdminLogin";
import AssignmentMarks from "../pages/AdminPortal/AssignmentMarks";
import Assignments from "../pages/AdminPortal/Assignments";
import Quizzes from "../pages/AdminPortal/Quizzes";
import Videos from "../pages/AdminPortal/Videos";
import CoursePlayer from "../pages/StudentPortal/CoursePlayer";
import Home from "../pages/StudentPortal/Home";
import Leaderboard from "../pages/StudentPortal/Leaderboard";
import Quiz from "../pages/StudentPortal/Quiz";
import StudentLogin from "../pages/StudentPortal/StudentLogin";
import StudentRegister from "../pages/StudentPortal/StudentRegister";
import AdminRoute from "./AdminRoute";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    children: [
      {
        path: "/",
        element: <PublicRoute> <StudentLogin /></PublicRoute>,
      },
      {
        path: "register",
        element: <PublicRoute><StudentRegister /></PublicRoute>,
      },
      {
        path: "lesson",
        element: <PrivateRoute><Home/></PrivateRoute>
      },
      {
        path: "lesson/:videoId",
        element: (
          <PrivateRoute>
            <CoursePlayer />
          </PrivateRoute>
        ),
      },
      {
        path: "lesson/quiz/:videoId",
        element: (
          <PrivateRoute>
            <Quiz />
          </PrivateRoute>
        ),
      },
      {
        path: "leaderboard",
        element: (
          <PrivateRoute>
            <Leaderboard />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: "/admin",
    element: <Dashboard />,
    children: [
      {
        path: "",
        element: <PublicRoute><AdminLogin /></PublicRoute>,
      },
      {
        path: "dashboard",
        element: <AdminRoute><AdminDashboard /></AdminRoute>
      },
      {
        path: "assignments",
        element: <AdminRoute><Assignments /></AdminRoute> 
      },
      {
        path: "videos",
        element: <AdminRoute><Videos /></AdminRoute> 
      },
      {
        path: "quizzes",
        element: <AdminRoute><Quizzes /></AdminRoute>
      },
      {
        path: "assignment-marks",
        element: <AdminRoute> <AssignmentMarks /></AdminRoute>
      }
    ],
  },
]);

export default routes;
